/* __next_internal_client_entry_do_not_use__ DevTools auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { isE2E } from "@faire/retailer-visitor-shared/lib/isE2E";
import { getIsProduction } from "@faire/retailer-visitor-shared/serialized-data/getEnvName";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import React, { Suspense } from "react";
import { LazyDevTools } from "@faire/retailer/components/DevTools";
export var DevTools = /*#__PURE__*/ React.memo(function() {
    var isSSR = useIsSSR();
    if (getIsProduction() || isE2E() || isSSR) {
        return null;
    }
    return /*#__PURE__*/ _jsx(Suspense, {
        fallback: null,
        children: /*#__PURE__*/ _jsx(LazyDevTools, {})
    });
});
